<template>
    <div>
        <div class="headerTabs">
            <el-tabs class="tabs" v-model="tabIndex" stretch>
                <el-tab-pane label="企业资质" name="0">
                    <div class="backs">
                        <img class="imgsBack" src="@/assets/mobileStatic/zzback.png" alt="">
                        <div class="imgs">
                            <div class="imgItem" @click="onShowImg(zz1)">
                                <img class="horizontal" :src="zz1" alt="">
                            </div>
                            <div class="imgItem" @click="onShowImg(zz2)">
                                <img class="vertical" src="@/assets/img/classic/zz/zz2.png" alt="">
                            </div>
                            <div class="imgItem" @click="onShowImg(zz3)">
                                <img class="vertical" src="@/assets/img/classic/zz/zz3.png" alt="">
                            </div>
                            <div class="imgItem" @click="onShowImg(zz4)">
                                <img class="vertical" src="@/assets/img/classic/zz/zz4.png" alt="">
                            </div>
                            <div class="imgItem" @click="onShowImg(zz7)">
                                <img class="horizontal" src="@/assets/img/classic/zz/zz7.png" alt="">
                            </div>
                            <div class="imgItem" @click="onShowImg(zz5)">
                                <img class="vertical" src="@/assets/img/classic/zz/zz5.png" alt="">
                            </div>

                            <div class="imgItem" @click="onShowImg(zz8)">
                                <img class="horizontal" src="@/assets/img/classic/zz/zz8.png" alt="">
                            </div>
                            <div class="imgItem" @click="onShowImg(zz6)">
                                <img class="vertical" src="@/assets/img/classic/zz/zz6.png" alt="">
                            </div>
                            <div class="imgItem" @click="onShowImg(zz9)">
                                <img class="horizontal" src="@/assets/img/classic/zz/zz9.png" alt="">
                            </div>

                            <div class="imgItem" @click="onShowImg(zz9_1)">
                                <img class="horizontal" src="@/assets/img/classic/zz/zz9_1.png" alt="">
                            </div>
                            <div class="imgItem" @click="onShowImg(zz10)">
                                <img class="vertical" src="@/assets/img/classic/zz/zz10.png" alt="">
                            </div>
                            <div class="imgItem" @click="onShowImg(zz9_2)">
                                <img class="horizontal" src="@/assets/img/classic/zz/zz9_2.png" alt="">
                            </div>

                            <div class="imgItem" @click="onShowImg(zz11)">
                                <img class="horizontal" src="@/assets/img/classic/zz/zz11.png" alt="">
                            </div>
                            <div class="imgItem" @click="onShowImg(zz12)">
                                <img class="horizontal" src="@/assets/img/classic/zz/zz12.png" alt="">
                            </div>
                            <div class="imgItem" @click="onShowImg(zz13)">
                                <img class="vertical" src="@/assets/img/classic/zz/zz13.png" alt="">
                            </div>



                        </div>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="荣誉奖项" name="1">
                    <div class="backsb">
                        <img class="imgsBack" src="@/assets/mobileStatic/ryback.png" alt="">
                        <div class="imgs">
                            <div class="imgItem" @click="onShowImg(zs6)">
                                <img class="vertical" :src="zs6" alt="">
                            </div>
                            <div class="imgItem" @click="onShowImg(jx1)">
                                <img class="horizontal" :src="jx1" alt="">
                            </div>
                            <div class="imgItem" @click="onShowImg(jx2)">
                                <img class="horizontal" :src="jx2" alt="">
                            </div>
                            <div class="imgItem" @click="onShowImg(jx3)">
                                <img class="horizontal" src="@/assets/img/classic/ry/jx3.png" alt="">
                            </div>
                            <div class="imgItem" @click="onShowImg(jx4)">
                                <img class="horizontal" src="@/assets/img/classic/ry/jx4.png" alt="">
                            </div>
                            <div class="imgItem" @click="onShowImg(jx5)">
                                <img class="horizontal" src="@/assets/img/classic/ry/jx5.png" alt="">
                            </div>

                            <div class="imgItem" @click="onShowImg(zs1)">
                                <img class="horizontal" src="@/assets/img/classic/ry/zs1.png" alt="">
                            </div>
                            <div class="imgItem" @click="onShowImg(zs2)">
                                <img class="horizontal" src="@/assets/img/classic/ry/zs2.png" alt="">
                            </div>
                            <div class="imgItem" @click="onShowImg(zs3)">
                                <img class="horizontal" src="@/assets/img/classic/ry/zs3.png" alt="">
                            </div>

                            <div class="imgItem" @click="onShowImg(zs4)">
                                <img class="horizontal" src="@/assets/img/classic/ry/zs4.png" alt="">
                            </div>
                            <div class="imgItem" @click="onShowImg(zs5)">
                                <img class="horizontal" src="@/assets/img/classic/ry/zs5.png" alt="">
                            </div>
                            <div class="imgItem" @click="onShowImg(zs7)">
                                <img class="horizontal" src="@/assets/img/classic/ry/zs7.png" alt="">
                            </div>

                            <div class="imgItem" @click="onShowImg(zs8)">
                                <img class="horizontal" src="@/assets/img/classic/ry/zs8.png" alt="">
                            </div>
                            <div class="imgItem" @click="onShowImg(zs9)">
                                <img class="horizontal" src="@/assets/img/classic/ry/zs9.png" alt="">
                            </div>




                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>



        <div class="showImg" v-show="show">
            <div class="delIcon" @click="show = false">
                <i class="el-icon-circle-close"></i>
            </div>

            <div class="contimg">
                <img :src="showImg" alt="">
            </div>
        </div>
    </div>
</template>
<script>
import zz1 from "@/assets/img/classic/zz/zz1.png"
import zz2 from "@/assets/img/classic/zz/zz2.png"
import zz3 from "@/assets/img/classic/zz/zz3.png"
import zz4 from "@/assets/img/classic/zz/zz4.png"
import zz5 from "@/assets/img/classic/zz/zz5.png"
import zz6 from "@/assets/img/classic/zz/zz6.png"
import zz7 from "@/assets/img/classic/zz/zz7.png"
import zz8 from "@/assets/img/classic/zz/zz8.png"
import zz9 from "@/assets/img/classic/zz/zz9.png"
import zz9_1 from "@/assets/img/classic/zz/zz9_1.png"

import zz9_2 from "@/assets/img/classic/zz/zz9_2.png"
import zz10 from "@/assets/img/classic/zz/zz10.png"
import zz11 from "@/assets/img/classic/zz/zz11.png"
import zz12 from "@/assets/img/classic/zz/zz12.png"
import zz13 from "@/assets/img/classic/zz/zz13.png"


import jx1 from "@/assets/img/classic/ry/jx1.png"
import jx2 from "@/assets/img/classic/ry/jx2.png"
import jx3 from "@/assets/img/classic/ry/jx3.png"
import jx4 from "@/assets/img/classic/ry/jx4.png"
import jx5 from "@/assets/img/classic/ry/jx5.png"
import zs1 from "@/assets/img/classic/ry/zs1.png"
import zs2 from "@/assets/img/classic/ry/zs2.png"
import zs3 from "@/assets/img/classic/ry/zs3.png"
import zs4 from "@/assets/img/classic/ry/zs4.png"

import zs5 from "@/assets/img/classic/ry/zs5.png"
import zs6 from "@/assets/img/classic/ry/zs6.png"
import zs7 from "@/assets/img/classic/ry/zs7.png"
import zs8 from "@/assets/img/classic/ry/zs8.png"
import zs9 from "@/assets/img/classic/ry/zs9.png"
export default {
    data() {
        return {
            tabIndex: '0',
            show: false,
            showImg: "",
            zz1: zz1,
            zz2: zz2,
            zz3: zz3,
            zz4: zz4,
            zz5: zz5,
            zz6: zz6,
            zz7: zz7,
            zz8: zz8,
            zz9: zz9,
            zz9_1: zz9_1,
            zz9_2: zz9_2,
            zz10: zz10,
            zz11: zz11,
            zz12: zz12,
            zz13: zz13,
            jx1: jx1,
            jx2: jx2,
            jx3: jx3,
            jx4: jx4,
            jx5: jx5,
            zs1: zs1,
            zs2: zs2,
            zs3: zs3,
            zs4: zs4,
            zs5: zs5,
            zs6: zs6,
            zs7: zs7,
            zs8: zs8,
            zs9: zs9


        }
    },
    methods: {
        onShowImg(url) {
            this.showImg = url;
            this.show = true;
        }
    }
}
</script>
<style lang="scss" scoped>

.showImg {
    position: fixed;
    top: 80px;
    left: 0;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 99;


    .delIcon {
        position: fixed;
        top: 120px;
        right: 30px;
        z-index: 1000;

        i {
            font-size: 50px;
            color: #fff;
        }
    }

    .contimg {
        display: flex;
        align-items: center;
        width: 100%;
        height: 100vh;

        img {
            width: 100%;
        }
    }
}

.backs {
    height: 100vh;
    width: 100%;
    overflow: hidden;
    overflow-y: auto;
    position: relative;

    .imgsBack {
        width: 100%;
        display: block;
        position: relative;
        z-index: 1;
    }

    .imgs {
        position: absolute;
        width: 100%;
        top: 0;
        z-index: 2;


        .imgItem {
            .horizontal {
                width: 239px;
                height: 169px;
                background-image: url('../../assets/mobileStatic/horizontal.png');
                background-size: 100% 100%;
                padding: 15px;
                box-sizing: border-box;
                overflow: hidden;
            }

            .vertical {
                width: 196px;
                height: 262px;
                background-image: url('../../assets/mobileStatic/vertical.png');
                background-size: 100% 100%;
                padding: 15px;
                box-sizing: border-box;
                overflow: hidden;
            }

            &:nth-child(1) {
                position: absolute;
                top: 23px;
                left: 261px;
            }

            &:nth-child(2) {
                position: absolute;
                top: 212px;
                left: 135px;
            }

            &:nth-child(3) {
                position: absolute;
                top: 212px;
                left: 415px;
            }

            &:nth-child(4) {
                position: absolute;
                top: 509px;
                left: 45px;
            }

            &:nth-child(5) {
                position: absolute;
                top: 524px;
                left: 258px;
            }

            &:nth-child(6) {
                position: absolute;
                top: 509px;
                right: 45px;
            }

            &:nth-child(7) {
                position: absolute;
                top: 809px;
                left: 10px;

                img {
                    width: 220px;
                }
            }

            &:nth-child(8) {
                position: absolute;
                top: 859px;
                left: 278px;
            }

            &:nth-child(9) {
                position: absolute;
                top: 809px;
                right: 10px;

                img {
                    width: 220px;
                }
            }

            &:nth-child(10) {
                position: absolute;
                top: 1050px;
                left: 10px;

                img {
                    width: 220px;
                }
            }

            &:nth-child(11) {
                position: absolute;
                top: 1180px;
                left: 278px;
            }

            &:nth-child(12) {
                position: absolute;
                top: 1050px;
                right: 10px;

                img {
                    width: 220px;
                }
            }

            &:nth-child(13) {
                position: absolute;
                top: 1360px;
                left: 10px;

                img {
                    width: 220px;
                }
            }

            &:nth-child(14) {
                position: absolute;
                top: 1360px;
                right: 10px;

                img {
                    width: 220px;
                }
            }

            &:nth-child(15) {
                position: absolute;
                top: 1480px;
                right: 278px;
            }

        }

        .boxs {
            background-image: url('../../assets/mobileStatic/ryback1.png');
            background-size: 100% 100%;
            width: 100%;
            height: 292px;
            position: absolute;
            top: 1050px;
            z-index: 3;
            display: flex;
            justify-content: space-between;

            box-sizing: border-box;

            .imgItemRow {
                margin-top: -120px;

                .horizontal {
                    width: 239px;
                    height: 169px;
                    background-image: url('../../assets/mobileStatic/horizontal.png');
                    background-size: 100% 100%;
                    padding: 15px;
                    box-sizing: border-box;
                    overflow: hidden;
                    flex-shrink: 0;
                }

                .vertical {
                    width: 196px;
                    height: 262px;
                    background-image: url('../../assets/mobileStatic/vertical.png');
                    background-size: 100% 100%;
                    padding: 15px;
                    box-sizing: border-box;
                    overflow: hidden;
                }
            }
        }

        .boxs1 {
            top: 1390px;
            z-index: 9;

        }

        .boxs2 {
            top: 1650px;
            z-index: 12;

            .imgItemRow {
                margin-top: -120px;

                &:nth-child(2) {
                    margin-top: -220px;
                }
            }
        }

        .boxs3 {
            top: 1500px;
            z-index: 15;


            .imgItemRow {
                margin-top: -120px;
                display: flex;
                justify-content: space-between;
            }
        }

        .one {
            background-image: url('../../assets/mobileStatic/ryback1.png');
            background-size: 100% 100%;
            width: 288px;
            height: 312px;
            position: absolute;
            top: 900px;
            left: 235px;
            z-index: 7;
            display: flex;
            justify-content: center;
            padding: 0 100px;
            box-sizing: border-box;

            .imgItemRow {
                margin-top: -120px;

                .horizontal {
                    width: 239px;
                    height: 169px;
                    background-image: url('../../assets/mobileStatic/horizontal.png');
                    background-size: 100% 100%;
                    padding: 15px;
                    box-sizing: border-box;
                    overflow: hidden;
                    flex-shrink: 0;
                }

                .vertical {
                    width: 196px;
                    height: 262px;
                    background-image: url('../../assets/mobileStatic/vertical.png');
                    background-size: 100% 100%;
                    padding: 15px;
                    box-sizing: border-box;
                    overflow: hidden;
                }
            }

        }

        .one1 {
            top: 1190px;
            z-index: 11;

            .imgItemRow {
                margin-top: -220px;
            }
        }

    }
}

.backsb {
    height: 100vh;
    width: 100%;
    overflow: hidden;
    overflow-y: auto;
    position: relative;
    .imgsBack {
        width: 100%;
        display: block;
        position: relative;
        z-index: 1;
    }

    .imgs {
        position: absolute;
        width: 100%;
        top: 0;
        z-index: 2;


        .imgItem {
            .horizontal {
                width: 239px;
                height: 169px;
                background-image: url('../../assets/mobileStatic/horizontal.png');
                background-size: 100% 100%;
                padding: 15px;
                box-sizing: border-box;
                overflow: hidden;
            }

            .vertical {
                width: 196px;
                height: 262px;
                background-image: url('../../assets/mobileStatic/vertical.png');
                background-size: 100% 100%;
                padding: 15px;
                box-sizing: border-box;
                overflow: hidden;
            }

            &:nth-child(1) {
                position: absolute;
                top: 193px;
                left: 261px;
            }

            &:nth-child(2) {
                position: absolute;
                top: 603px;
                left: 10px;
            }

            &:nth-child(3) {
                position: absolute;
                top: 603px;
                right: 10px;
            }

            &:nth-child(4) {
                position: absolute;
                top: 809px;
                left: 45px;
            }

            &:nth-child(5) {
                position: absolute;
                top: 524px;
                left: 258px;
            }

            &:nth-child(6) {
                position: absolute;
                top: 809px;
                right: 45px;
            }

            &:nth-child(7) {
                position: absolute;
                top: 1039px;
                left: 10px;

                img {
                    width: 220px;
                }
            }

            &:nth-child(8) {
                position: absolute;
                top: 959px;
                left: 255px;
            }

            &:nth-child(9) {
                position: absolute;
                top: 1039px;
                right: 10px;

                img {
                    width: 220px;
                }
            }

            &:nth-child(10) {
                position: absolute;
                top: 1250px;
                left: 10px;

                img {
                    width: 220px;
                }
            }

            &:nth-child(11) {
                position: absolute;
                top: 1250px;
                right: 10px;
            }

            &:nth-child(12) {
                position: absolute;
                top: 1400px;
                right: 278px;

                img {
                    width: 220px;
                }
            }

            &:nth-child(13) {
                position: absolute;
                top: 1500px;
                left: 10px;

                img {
                    width: 220px;
                }
            }

            &:nth-child(14) {
                position: absolute;
                top: 1500px;
                right: 10px;

                img {
                    width: 220px;
                }
            }


        }

        .boxs {
            background-image: url('../../assets/mobileStatic/ryback1.png');
            background-size: 100% 100%;
            width: 100%;
            height: 292px;
            position: absolute;
            top: 1050px;
            z-index: 3;
            display: flex;
            justify-content: space-between;

            box-sizing: border-box;

            .imgItemRow {
                margin-top: -120px;

                .horizontal {
                    width: 239px;
                    height: 169px;
                    background-image: url('../../assets/mobileStatic/horizontal.png');
                    background-size: 100% 100%;
                    padding: 15px;
                    box-sizing: border-box;
                    overflow: hidden;
                    flex-shrink: 0;
                }

                .vertical {
                    width: 196px;
                    height: 262px;
                    background-image: url('../../assets/mobileStatic/vertical.png');
                    background-size: 100% 100%;
                    padding: 15px;
                    box-sizing: border-box;
                    overflow: hidden;
                }
            }
        }

        .boxs1 {
            top: 1390px;
            z-index: 9;

        }

        .boxs2 {
            top: 1650px;
            z-index: 12;

            .imgItemRow {
                margin-top: -120px;

                &:nth-child(2) {
                    margin-top: -220px;
                }
            }
        }

        .boxs3 {
            top: 1500px;
            z-index: 15;


            .imgItemRow {
                margin-top: -120px;
                display: flex;
                justify-content: space-between;
            }
        }

        .one {
            background-image: url('../../assets/mobileStatic/ryback1.png');
            background-size: 100% 100%;
            width: 288px;
            height: 312px;
            position: absolute;
            top: 900px;
            left: 235px;
            z-index: 7;
            display: flex;
            justify-content: center;
            padding: 0 100px;
            box-sizing: border-box;

            .imgItemRow {
                margin-top: -120px;

                .horizontal {
                    width: 239px;
                    height: 169px;
                    background-image: url('../../assets/mobileStatic/horizontal.png');
                    background-size: 100% 100%;
                    padding: 15px;
                    box-sizing: border-box;
                    overflow: hidden;
                    flex-shrink: 0;
                }

                .vertical {
                    width: 196px;
                    height: 262px;
                    background-image: url('../../assets/mobileStatic/vertical.png');
                    background-size: 100% 100%;
                    padding: 15px;
                    box-sizing: border-box;
                    overflow: hidden;
                }
            }

        }

        .one1 {
            top: 1190px;
            z-index: 11;

            .imgItemRow {
                margin-top: -220px;
            }
        }

    }
}

::v-deep .tabs {
    position: fixed;
    top: 0;
    width: 100%;

    .el-tabs__header {
        margin-bottom: 10px;
        background-color: #fff;

        .el-tabs__nav-wrap {
            padding: 0 20px;
        }
    }

    .el-tabs__item {
        height: 90px;
        line-height: 90px;
        font-size: 28px;
    }

    .el-collapse-item__header {
        height: 90px;

        .title {
            display: flex;
            align-items: center;
            padding: 0 20px;
            font-size: 28px;

            img {
                width: 50px;
            }

            span {
                margin-left: 20px;
            }
        }

    }
}</style>